import React, { useState } from 'react';
import { Phone, FileText, X, ChevronRight, Star, Award, Eye, Coffee, Dumbbell, Wifi, Car, Shield, Smartphone, Users, Calendar, MapPin, Check, Building, Home, Hotel, Briefcase, Crown, Bed, Bath, Maximize, Minimize, ArrowRight, Play, Circle, Grid, Layers, Menu } from 'lucide-react';
import BurjQuaidCover from '../images/projects/burj_quaid_cover.png';
import { Helmet } from 'react-helmet-async';

/* =========================================================
   YouTube video config
   ========================================================= */
const YOUTUBE_VIDEO_ID = "J69-D9rWQ98";
const YOUTUBE_THUMBNAIL = `https://img.youtube.com/vi/${YOUTUBE_VIDEO_ID}/maxresdefault.jpg`;
const YOUTUBE_THUMBNAIL_FALLBACK = `https://img.youtube.com/vi/${YOUTUBE_VIDEO_ID}/hqdefault.jpg`;
const YOUTUBE_EMBED_URL = `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&rel=0&modestbranding=1`;

const BurjQuaidLanding = () => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showFloorPlanModal, setShowFloorPlanModal] = useState(false);
  const [activeTab, setActiveTab] = useState('residential');
  const [showVideo, setShowVideo] = useState(false);
  const [thumbSrc, setThumbSrc] = useState(YOUTUBE_THUMBNAIL);

  const handleWhatsApp = () => {
    window.open(`https://wa.me/923487172565`, '_blank');
  };

  // All content extracted from PDFs
  const content = {
    hero: {
      title: "BURJ QUAID",
      subtitle: "Pakistan's Tallest Tower",
      tagline: "Live Above the Clouds",
      background: BurjQuaidCover
    },
    about: {
      developer: "ABS Developers",
      ceo: "Dr. Subayyal Ikram",
      ceoTitle: "CEO - ABS Developers",
      description: "At ABS Developers, we began with a clear commitment: to build the right way. A pioneer in shariah-compliant real estate, our foundation rests on transparency, security, and trust. From high-rises to commercial hubs, we have consistently delivered projects that combine quality materials, strict timelines, and practical luxury. Our developments include some of the tallest towers across major cities, because we believe Pakistan's urban centers deserve landmarks that reflect ambition and long-term value. With Burj Quaid in Karachi, we are taking this vision global, creating Pakistan's tallest tower, a modern symbol of elevated living and premium retail that embodies national pride while reflecting Quaid-e-Azam's vision of a progressive, disciplined, and self-reliant Pakistan.",
      ceoQuote: "When we started ABS Developers, the idea was never just to put up buildings, it was to build trust. Back then, Shariah-compliance wasn't the norm in Pakistan, but we chose to lead with principle, and that one choice shaped everything that followed."
    },
    atAGlance: [
      "Tallest Tower of Pakistan",
      "Highest Mosque of Pakistan",
      "Highest Observation Deck in Pakistan",
      "Highest Occupied Floor in Pakistan",
      "Highest Service Elevator in Pakistan",
      "Approved Height of 941 Feet (286.8m)"
    ],
    amenities: [
      "Sky Walk", "5-Star Hotel", "Infinity Pool", "Grand Auditorium",
      "Gymnasium", "Jogging Tracks", "Badminton Courts", "Indoor Water Park",
      "Indoor Swimming Pools", "Fine Dining", "Courtyard Restaurant",
      "Sky Gardens", "Sky-High Lounge & Cafe", "Premium Badminton Court",
      "AI-Powered Smart Infrastructure", "Enterprise-Grade Connectivity",
      "Business Hub", "24/7 Security", "Concierge Services", "Valet Parking",
      "Conference Rooms", "Co-working Spaces", "Children's Play Area",
      "Meditation Zones", "Walking Trails", "Outdoor Seating Areas"
    ],
    highlights: [
      "Pakistan's 1st Advanced Integrated Business Hub",
      "100+ Amenities",
      "Spectacular Panoramic Views",
      "Premium Finishes & Expansive Interiors",
      "Shariah-Compliant Investment"
    ],
    skyWalk: {
      title: "SKY WALK",
      description: "An iconic Sky Walk offering breathtaking panoramic views above the clouds."
    },
    hotel: {
      title: "5 STAR HOTEL",
      subtitle: "LUXURY CHECKS INTO PAKISTAN'S TALLEST TOWER",
      description: "Arrive at a destination unlike any other. An iconic entrance creates a remarkable first impression, welcoming guests into an atmosphere of luxury and gracious hospitality. Spectacular views, elegant suites and exceptional service create memorable stays for business leaders, international travellers and discerning guests. Burj Quaid's five-star hotel brings global hospitality standards to Pakistan's tallest tower. It offers an experience that begins above the clouds and stays with you long after the departure."
    },
    businessHub: {
      title: "PAKISTAN'S 1ST ADVANCED INTEGRATED BUSINESS HUB",
      description: "Success begins with vision. Burj Quaid designed for entrepreneurs, innovators and global enterprises. Smart infrastructure, AI-powered systems, enterprise-grade connectivity and inspiring workspaces create an environment where bold decisions shape the future."
    },
    residences: {
      title: "LIVE ABOVE THE CLOUDS",
      description: "Spectacular views create a breathtaking panorama beyond the horizon. Expansive interiors invite abundant natural light, while premium finishes elevate everyday living. Sky Gardens introduce refreshing green spaces, creating a tranquil retreat above the city. Burj Quaid offers an exceptional experience for those who appreciate distinction.",
      penthouseBedroom: {
        title: "REST ABOVE THE CITY",
        description: "The penthouse bedroom is calm, private, and magnificent. Rich materials create warmth. Generous proportions inspire comfort. Panoramic views transform mornings and evenings alike. A remarkable retreat shaped for luxurious living."
      },
      penthouseLounge: {
        title: "GATHER IN GRANDEUR",
        description: "The penthouse lounge welcomes remarkable occasions. Spacious interiors encourage celebration and conversation. The dining area complements memorable evenings with family and guests. Inspiring views complete an extraordinary setting worthy of life's finest moments."
      },
      exclusivity: {
        title: "A NEW HEIGHT OF EXCLUSIVITY",
        description: "Beyond its iconic elevation lies a world reserved for the perfection seekers. Burj Quaid combines architectural brilliance with exceptional residences, spectacular views and exquisite living spaces. A landmark where prestige is not only admired, but experienced every day."
      },
      apartment: {
        title: "SERENE BY DESIGN",
        description: "The apartment bedroom blends comfort with distinguished character. Bright interiors create a peaceful atmosphere, while premium finishes enrich every detail. The modern kitchen combines elegant design with exceptional functionality, creating a refined space for everyday cooking and entertaining. Spacious interiors encourage meaningful conversations, while spectacular panoramic views provide an inspiring backdrop."
      }
    },
    lifestyle: {
      title: "PAKISTAN'S TALLEST TOWER, PAKISTAN'S FINEST LIFESTYLE",
      description: "Every floor introduces a new experience. Every view tells a new story. Float beside the infinity pool. Celebrate at the grand auditorium. Stay active at the gymnasium, jogging tracks and badminton courts. Enjoy the indoor water park, indoor swimming pools, fine dining, courtyard restaurant and beautifully designed Sky Gardens. Experience a destination where luxury, leisure and unforgettable experiences come together above in the most remarkable manner."
    },
    spaces: {
      title: "SPACES THAT BRING PEOPLE TOGETHER",
      description: "Life is enriched through playful moments. Challenge yourself on the premium badminton court or gather in the grand auditorium for celebrations, conferences and inspiring events. Exclusively designed spaces where every experience expresses the prestige of Burj Quaid."
    },
    moments: {
      title: "WHERE EVERY MOMENT FINDS ITS PLACE",
      description: "Reach new heights of luxury with Pakistan's Tallest Tower. Unwind at the sky-high lounge and cafe while breathtaking views unfold before you."
    },
    night: {
      title: "PAKISTAN'S BRIGHTEST ICON AFTER SUNSET",
      description: "As the city lights glow, Burj Quaid shines above them all. It's radiant architecture stands proudly as the sparkling landmark that celebrates ambition. A destination that continues to inspire, day and night."
    },
    floorPlans: {
      residential: [
        {
          name: "1 BED SIGNATURE Apartment",
          netArea: "527 Sqft",
          grossArea: "660 Sqft",
          image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        },
        {
          name: "1 BED ROYAL Apartment",
          netArea: "871 Sqft",
          grossArea: "1090 Sqft",
          image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        },
        {
          name: "2 BED SIGNATURE Apartment",
          netArea: "1183 Sqft",
          grossArea: "1480 Sqft",
          image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        },
        {
          name: "2 BED ROYAL Apartment",
          netArea: "1747 Sqft",
          grossArea: "2185 Sqft",
          image: "https://images.unsplash.com/photo-1560185127-6ed189bf02f4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        },
        {
          name: "3 BED SIGNATURE Apartment",
          netArea: "1747 Sqft",
          grossArea: "2185 Sqft",
          image: "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        }
      ],
      commercial: [
        {
          name: "Commercial Office",
          area: "400 Sqft",
          image: "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        },
        {
          name: "Commercial Office",
          area: "600 Sqft",
          image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        },
        {
          name: "Commercial Office",
          area: "1000 Sqft",
          image: "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
        }
      ],
      categories: [
        "General",
        "Corner",
        "Facing boulevard",
        "West open",
        "Corner + west open",
        "Facing boulevard + corner",
        "Facing boulevard + corner + west open"
      ],
      inclusions: [
        "Entrance Door with Lock",
        "Bedroom Wardrobes",
        "Internal Doors & Hardware",
        "Kitchen Cabinets",
        "Floor Tiles",
        "Kitchen Countertop",
        "Wall Paint",
        "Kitchen Hood, Hob & Sink",
        "False Ceiling (where applicable)",
        "Kitchen Exhaust",
        "Lighting Fixtures",
        "Washrooms with Sanitary Fittings",
        "Electrical Switches & Power Sockets",
        "Washroom Vanity with Mirror",
        "Windows",
        "Balcony Glass Railing"
      ]
    },
    paymentPlan: {
      note: "All areas are gross & approximate. The payment plan is subject to unit availability. Installment plan starts from 1st October 2026. All terms & conditions set by Burj Quaid Management apply. Additional 10% will be charged for single category, 15% for double category & 20% for triple category.",
      categories: [
        { type: "Residential 1-Bed (660 sqft)", rate: "26,999", downPayment: "2,700,000", quarterly: "625,000", last: "744,340", total: "17,819,340" },
        { type: "Residential 1-Bed (1090 sqft)", rate: "26,999", downPayment: "4,400,000", quarterly: "1,025,000", last: "1,453,910", total: "29,428,910" },
        { type: "Residential 2-Bed (1480 sqft)", rate: "26,999", downPayment: "6,000,000", quarterly: "1,400,000", last: "1,758,520", total: "39,958,520" },
        { type: "Residential 2-Bed (2185 sqft)", rate: "26,999", downPayment: "8,800,000", quarterly: "2,075,000", last: "2,467,815", total: "58,992,815" },
        { type: "Residential 3-Bed (2185 sqft)", rate: "26,999", downPayment: "8,800,000", quarterly: "2,075,000", last: "2,467,815", total: "58,992,815" },
        { type: "Residential 3-Bed (3055 sqft)", rate: "26,999", downPayment: "12,400,000", quarterly: "2,875,000", last: "3,956,945", total: "82,481,945" },
        { type: "Residential 3-Bed (4130 sqft)", rate: "26,999", downPayment: "16,700,000", quarterly: "3,900,000", last: "5,105,870", total: "111,505,870" },
        { type: "Residential 4-Bed (5315 sqft)", rate: "26,999", downPayment: "21,500,000", quarterly: "5,025,000", last: "6,424,685", total: "143,499,685" },
        { type: "Commercial Office (400 sqft)", rate: "55,000", downPayment: "3,300,000", quarterly: "7,750,000", last: "875,000", total: "22,000,000" },
        { type: "Commercial Office (600 sqft)", rate: "55,000", downPayment: "5,000,000", quarterly: "1,150,000", last: "1,550,000", total: "33,000,000" },
        { type: "Commercial Office (1000 sqft)", rate: "55,000", downPayment: "8,300,000", quarterly: "1,925,000", last: "2,425,000", total: "55,000,000" }
      ]
    },
    location: {
      title: "WELCOME TO DHA CITY KARACHI",
      places: ["Fairwinds Golf Course", "DHA Suffa University", "Shaukat Khanum Hospital"],
      image: "https://images.unsplash.com/photo-1523731407965-2430cd12f5e4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
    },
    whatsapp: "923487172565"
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "RealEstateListing",
    "name": "Burj Quaid - Pakistan's Tallest Tower",
    "description": "Burj Quaid is Pakistan's tallest tower in DHA City Karachi. Features luxury apartments, 5-star hotel, Sky Walk, and 100+ amenities. Shariah-compliant real estate investment.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "DHA City",
      "addressLocality": "Karachi",
      "addressRegion": "Sindh",
      "addressCountry": "PK"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "PKR",
      "price": "17819340",
      "availability": "https://schema.org/PreOrder"
    }
  };

  return (
    <div className="font-sans text-gray-800 bg-white overflow-x-hidden">
      <Helmet>
        <title>Burj Quaid - Pakistan's Tallest Tower | DHA City Karachi</title>
        <meta name="description" content="Burj Quaid is Pakistan's tallest tower at 941 feet in DHA City Karachi. Offering luxury apartments, 5-star hotel, Sky Walk, and 100+ amenities. Shariah-compliant investment by ABS Developers." />
        <meta name="keywords" content="Burj Quaid, Pakistan's Tallest Tower, DHA City Karachi, ABS Developers, Luxury Apartments Karachi, 5-Star Hotel Karachi, Sky Walk Pakistan, Real Estate Investment Karachi" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://burjquaid.com/" />
        <meta property="og:title" content="Burj Quaid - Pakistan's Tallest Tower | DHA City Karachi" />
        <meta property="og:description" content="Burj Quaid is Pakistan's tallest tower at 941 feet. Experience luxury living with a 5-star hotel, Sky Walk, and 100+ amenities in DHA City Karachi." />
        <meta property="og:image" content={BurjQuaidCover} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://burjquaid.com/" />
        <meta property="twitter:title" content="Burj Quaid - Pakistan's Tallest Tower | DHA City Karachi" />
        <meta property="twitter:description" content="Burj Quaid is Pakistan's tallest tower at 941 feet. Experience luxury living with a 5-star hotel, Sky Walk, and 100+ amenities in DHA City Karachi." />
        <meta property="twitter:image" content={BurjQuaidCover} />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "VideoObject",
            "name": "Burj Quaid - Pakistan's Tallest Tower Intro",
            "description": "Official introduction video of Burj Quaid, Pakistan's tallest tower in DHA City Karachi.",
            "thumbnailUrl": [YOUTUBE_THUMBNAIL],
            "uploadDate": "2024-01-01",
            "embedUrl": `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}`,
            "contentUrl": `https://www.youtube.com/watch?v=${YOUTUBE_VIDEO_ID}`
          })}
        </script>
      </Helmet>

      {/* Hero Section */}
      <section
        className="relative min-h-screen flex items-center justify-center text-center text-white px-4"
        style={{
          backgroundImage: `url(${BurjQuaidCover})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
        <div className="relative z-10 max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-8xl font-bold tracking-tight drop-shadow-lg">{content.hero.title}</h1>
          <p className="text-2xl md:text-4xl font-light mt-2 text-yellow-300">{content.hero.subtitle}</p>
          <p className="text-xl md:text-2xl mt-4 text-gray-200">{content.hero.tagline}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <button
              onClick={() => setShowPaymentModal(true)}
              className="flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-black font-semibold py-3 px-8 rounded-full transition shadow-lg text-lg"
            >
              <FileText size={22} /> View Payment Plan
            </button>
            <button
              onClick={() => setShowFloorPlanModal(true)}
              className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-semibold py-3 px-8 rounded-full transition shadow-lg text-lg"
            >
              <Layers size={22} /> View Floor Plans
            </button>
            <button
              onClick={handleWhatsApp}
              className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-500 text-white font-semibold py-3 px-8 rounded-full transition shadow-lg text-lg"
            >
              <Phone size={22} /> Contact via WhatsApp
            </button>
          </div>
        </div>
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ChevronRight size={32} className="rotate-90 text-white/70" />
        </div>
      </section>

      {/* =========================================================
          VIDEO SECTION — YouTube intro
          ========================================================= */}
      <section className="py-20 px-6 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 bg-yellow-500/20 border border-yellow-500/40 text-yellow-300 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <Play size={16} /> Official Introduction
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Experience Burj Quaid
            </h2>
            <p className="text-gray-400 max-w-2xl mx-auto text-lg">
              Watch the official introduction to Pakistan's tallest tower — an icon of ambition rising 941 feet above DHA City, Karachi.
            </p>
          </div>

          <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl ring-1 ring-yellow-500/30">
            {showVideo ? (
              <iframe
                className="w-full h-full"
                src={YOUTUBE_EMBED_URL}
                title="Burj Quaid - Pakistan's Tallest Tower Intro"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            ) : (
              <button
                type="button"
                onClick={() => setShowVideo(true)}
                className="group w-full h-full block relative cursor-pointer bg-black"
                aria-label="Play Burj Quaid introduction video"
              >
                <img
                  src={thumbSrc}
                  onError={() => setThumbSrc(YOUTUBE_THUMBNAIL_FALLBACK)}
                  alt="Burj Quaid - Pakistan's Tallest Tower (official intro video)"
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-700 opacity-90 group-hover:opacity-100"
                  loading="lazy"
                />
                {/* Dark gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                {/* Play button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="relative">
                    <span className="absolute inset-0 rounded-full bg-yellow-500/40 animate-ping"></span>
                    <span className="relative flex items-center justify-center w-24 h-24 md:w-28 md:h-28 rounded-full bg-yellow-500 hover:bg-yellow-400 text-black shadow-2xl transition group-hover:scale-110">
                      <Play size={44} className="ml-1" fill="currentColor" />
                    </span>
                  </div>
                </div>

                {/* Caption at bottom */}
                <div className="absolute bottom-0 left-0 right-0 p-6 text-left">
                  <p className="text-yellow-400 font-semibold text-sm">Official Intro</p>
                  <p className="text-white text-xl md:text-2xl font-bold">
                    Burj Quaid — Live Above the Clouds
                  </p>
                </div>
              </button>
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <button
              onClick={handleWhatsApp}
              className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-500 text-white font-semibold py-3 px-8 rounded-full transition shadow-lg"
            >
              <Phone size={20} /> Book a Site Visit
            </button>
            <button
              onClick={() => setShowPaymentModal(true)}
              className="flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-black font-semibold py-3 px-8 rounded-full transition shadow-lg"
            >
              <FileText size={20} /> View Payment Plan
            </button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 px-6 max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="flex items-center gap-2 text-yellow-600 mb-2">
              <Building size={20} />
              <span className="font-semibold">ABOUT {content.about.developer}</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Building Trust, <br/>Building Pakistan</h2>
            <p className="text-gray-700 leading-relaxed mb-6">{content.about.description}</p>
            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg">
              <p className="italic text-gray-700 text-lg">"{content.about.ceoQuote}"</p>
              <p className="font-semibold mt-3 text-gray-900">— {content.about.ceo}, {content.about.ceoTitle}</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {content.atAGlance.map((item, idx) => (
              <div key={idx} className="bg-gray-50 p-5 rounded-xl shadow-sm border border-gray-100 flex items-start gap-3 hover:shadow-md transition">
                <Star size={20} className="text-yellow-500 flex-shrink-0 mt-1" />
                <span className="text-sm font-medium text-gray-800">{item}</span>
              </div>
            ))}
            <div className="sm:col-span-2 bg-gradient-to-r from-yellow-500 to-yellow-400 p-5 rounded-xl text-center text-black font-bold">
              <span className="text-2xl">941 FT</span>
              <span className="block text-sm font-normal">Approved Height (286.8m)</span>
            </div>
          </div>
        </div>
      </section>

      {/* Highlights Banner */}
      <section className="bg-gradient-to-r from-yellow-500 to-yellow-400 py-12 px-6">
        <div className="max-w-7xl mx-auto grid md:grid-cols-5 gap-4 text-center">
          {content.highlights.map((item, idx) => (
            <div key={idx} className="flex items-center justify-center gap-2 text-black font-semibold">
              <Award size={24} className="flex-shrink-0" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Sky Walk & Hotel Section */}
      <section className="py-20 px-6 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8">
          <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-xl group">
            <img src="https://images.unsplash.com/photo-1540541338287-41700207dee6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Sky Walk at Burj Quaid" className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <h3 className="text-3xl font-bold text-white">{content.skyWalk.title}</h3>
              <p className="text-gray-200 text-lg mt-2">{content.skyWalk.description}</p>
            </div>
          </div>
          <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-xl group">
            <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="5-Star Hotel at Burj Quaid" className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="flex items-center gap-2 mb-2">
                <Hotel size={24} className="text-yellow-400" />
                <span className="text-yellow-400 font-semibold">5 STAR HOTEL</span>
              </div>
              <h3 className="text-2xl font-bold text-white">{content.hotel.subtitle}</h3>
              <p className="text-gray-200 text-sm mt-2 line-clamp-3">{content.hotel.description}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Business Hub */}
      <section className="py-20 px-6 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="flex items-center gap-2 text-yellow-400 mb-4">
              <Briefcase size={24} />
              <span className="font-semibold">Commercial</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6">{content.businessHub.title}</h2>
            <p className="text-gray-300 text-lg leading-relaxed mb-8">{content.businessHub.description}</p>
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 bg-gray-800 px-5 py-3 rounded-full"><Smartphone size={20} /> AI-Powered</div>
              <div className="flex items-center gap-2 bg-gray-800 px-5 py-3 rounded-full"><Wifi size={20} /> Enterprise Connectivity</div>
              <div className="flex items-center gap-2 bg-gray-800 px-5 py-3 rounded-full"><Users size={20} /> Co-working Spaces</div>
              <div className="flex items-center gap-2 bg-gray-800 px-5 py-3 rounded-full"><Shield size={20} /> 24/7 Security</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Business Hub" className="rounded-xl h-64 object-cover col-span-2" />
            <img src="https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Office Space" className="rounded-xl h-48 object-cover" />
            <img src="https://images.unsplash.com/photo-1497366672149-e2e1b5d6a1f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Workspace" className="rounded-xl h-48 object-cover" />
          </div>
        </div>
      </section>

      {/* Residences - Live Above the Clouds */}
      <section className="py-20 px-6 max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-4">{content.residences.title}</h2>
        <p className="text-center text-gray-600 max-w-3xl mx-auto mb-12 text-lg">{content.residences.description}</p>

        <div className="grid md:grid-cols-3 gap-6">
          <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-100 group">
            <div className="relative h-72 overflow-hidden">
              <img src="https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Penthouse Bedroom" className="w-full h-full object-cover group-hover:scale-110 transition duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-0 p-6">
                <span className="text-yellow-400 font-semibold">Penthouse</span>
                <h4 className="text-2xl font-bold text-white">{content.residences.penthouseBedroom.title}</h4>
              </div>
            </div>
            <div className="p-6">
              <p className="text-gray-600">{content.residences.penthouseBedroom.description}</p>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-100 group">
            <div className="relative h-72 overflow-hidden">
              <img src="https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Penthouse Lounge" className="w-full h-full object-cover group-hover:scale-110 transition duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-0 p-6">
                <span className="text-yellow-400 font-semibold">Penthouse</span>
                <h4 className="text-2xl font-bold text-white">{content.residences.penthouseLounge.title}</h4>
              </div>
            </div>
            <div className="p-6">
              <p className="text-gray-600">{content.residences.penthouseLounge.description}</p>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-100 group">
            <div className="relative h-72 overflow-hidden">
              <img src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Luxury Apartment" className="w-full h-full object-cover group-hover:scale-110 transition duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-0 p-6">
                <span className="text-yellow-400 font-semibold">Apartment</span>
                <h4 className="text-2xl font-bold text-white">{content.residences.apartment.title}</h4>
              </div>
            </div>
            <div className="p-6">
              <p className="text-gray-600">{content.residences.apartment.description}</p>
            </div>
          </div>
        </div>

        <div className="mt-12 bg-gray-50 rounded-2xl p-8 border border-gray-100">
          <h4 className="text-2xl font-bold text-center mb-2">{content.residences.exclusivity.title}</h4>
          <p className="text-center text-gray-600 max-w-3xl mx-auto">{content.residences.exclusivity.description}</p>
        </div>
      </section>

      {/* Lifestyle Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-6">{content.lifestyle.title}</h2>
          <p className="text-center text-gray-300 max-w-3xl mx-auto mb-12 text-lg">{content.lifestyle.description}</p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {content.amenities.slice(0, 16).map((amenity, idx) => (
              <div key={idx} className="bg-white/10 backdrop-blur-sm p-4 rounded-xl flex items-center gap-3 hover:bg-white/20 transition">
                <Check size={18} className="text-yellow-400 flex-shrink-0" />
                <span className="text-sm">{amenity}</span>
              </div>
            ))}
          </div>
          <div className="text-center mt-6 text-gray-400">+ {content.amenities.length - 16} more amenities</div>
        </div>
      </section>

      {/* Spaces That Bring People Together */}
      <section className="py-20 px-6 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6">{content.spaces.title}</h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">{content.spaces.description}</p>
            <div className="flex flex-wrap gap-4">
              <div className="bg-yellow-100 px-6 py-3 rounded-full text-yellow-800 font-semibold flex items-center gap-2">
                <Crown size={20} /> Premium Badminton Court
              </div>
              <div className="bg-blue-100 px-6 py-3 rounded-full text-blue-800 font-semibold flex items-center gap-2">
                <Calendar size={20} /> Grand Auditorium
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Gymnasium" className="rounded-xl h-64 object-cover" />
            <img src="https://images.unsplash.com/photo-1519677100203-a0e668c92439?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Swimming Pool" className="rounded-xl h-64 object-cover" />
            <img src="https://images.unsplash.com/photo-1492684223066-81342ee5ff30?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Auditorium" className="rounded-xl h-48 object-cover col-span-2" />
          </div>
        </div>
      </section>

      {/* Moments & Night Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <h3 className="text-3xl font-bold mb-4">{content.moments.title}</h3>
            <p className="text-gray-600 text-lg">{content.moments.description}</p>
            <div className="mt-6 flex items-center gap-3 text-yellow-600">
              <Coffee size={24} />
              <span>Sky-High Lounge & Cafe</span>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-xl">
            <img src="https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Night View of Burj Quaid" className="w-full h-full object-cover min-h-[300px]" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-8">
              <div>
                <h3 className="text-3xl font-bold text-white">{content.night.title}</h3>
                <p className="text-gray-200">{content.night.description}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Location */}
      <section className="py-20 px-6 max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-4">{content.location.title}</h2>
        <div className="grid md:grid-cols-3 gap-4 mb-8">
          {content.location.places.map((place, idx) => (
            <div key={idx} className="bg-gray-50 p-5 rounded-xl shadow flex items-center gap-3 border border-gray-100">
              <MapPin className="text-red-500 flex-shrink-0" size={24} />
              <span className="font-medium">{place}</span>
            </div>
          ))}
        </div>
        <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl">
          <img src={content.location.image} alt="DHA City Karachi Location" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
            <div className="bg-white/95 backdrop-blur-sm px-8 py-6 rounded-2xl shadow-2xl text-center">
              <Building className="text-yellow-600 mx-auto mb-2" size={32} />
              <span className="text-2xl font-bold text-gray-900">DHA City, Karachi</span>
              <p className="text-gray-600">Pakistan's Premier Location</p>
            </div>
          </div>
        </div>
      </section>

      {/* Floor Plans Modal */}
      {showFloorPlanModal && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-white rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto relative shadow-2xl">
            <button
              onClick={() => setShowFloorPlanModal(false)}
              className="sticky top-4 float-right z-10 bg-white rounded-full p-2 shadow-md hover:bg-gray-100 mr-4 mt-4"
            >
              <X size={28} />
            </button>
            <div className="p-6 pt-0">
              <h2 className="text-3xl font-bold text-center mb-2">Floor Plans</h2>
              <p className="text-center text-gray-500 mb-6">2 & 3 Bedroom Typical Floor Layouts</p>

              <div className="flex gap-2 mb-6 justify-center">
                <button
                  onClick={() => setActiveTab('residential')}
                  className={`px-6 py-2 rounded-full font-semibold transition ${activeTab === 'residential' ? 'bg-yellow-500 text-black' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  Residential
                </button>
                <button
                  onClick={() => setActiveTab('commercial')}
                  className={`px-6 py-2 rounded-full font-semibold transition ${activeTab === 'commercial' ? 'bg-yellow-500 text-black' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
                >
                  Commercial
                </button>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                {(activeTab === 'residential' ? content.floorPlans.residential : content.floorPlans.commercial).map((plan, idx) => (
                  <div key={idx} className="border rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition">
                    <img src={plan.image} alt={plan.name} className="w-full h-56 object-cover" />
                    <div className="p-4">
                      <h4 className="font-bold text-lg">{plan.name}</h4>
                      <p className="text-gray-600">Net Area: {plan.netArea || plan.area}</p>
                      {plan.grossArea && <p className="text-gray-600">Gross Area: {plan.grossArea}</p>}
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8">
                <h4 className="font-bold text-xl mb-3">Category Types</h4>
                <div className="flex flex-wrap gap-2">
                  {content.floorPlans.categories.map((cat, idx) => (
                    <span key={idx} className="bg-gray-100 px-4 py-2 rounded-full text-sm">{cat}</span>
                  ))}
                </div>
              </div>

              <div className="mt-6">
                <h4 className="font-bold text-xl mb-3">What's Included in the Apartment</h4>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                  {content.floorPlans.inclusions.map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2 text-sm">
                      <Check size={16} className="text-green-500 flex-shrink-0" />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Payment Plan Modal */}
      {showPaymentModal && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-white rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto relative shadow-2xl">
            <button
              onClick={() => setShowPaymentModal(false)}
              className="sticky top-4 float-right z-10 bg-white rounded-full p-2 shadow-md hover:bg-gray-100 mr-4 mt-4"
            >
              <X size={28} />
            </button>
            <div className="p-6 pt-0">
              <h2 className="text-3xl font-bold text-center mb-2">Payment Plan</h2>
              <p className="text-center text-gray-500 mb-6">{content.paymentPlan.note}</p>
              <div className="overflow-x-auto">
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr className="bg-yellow-100 text-gray-700">
                      <th className="p-3 border text-left">Category / Type</th>
                      <th className="p-3 border text-right">Rate (PKR/sqft)</th>
                      <th className="p-3 border text-right">Down Payment</th>
                      <th className="p-3 border text-right">Quarterly x 23</th>
                      <th className="p-3 border text-right">Last Payment</th>
                      <th className="p-3 border text-right">Grand Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {content.paymentPlan.categories.map((item, idx) => (
                      <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                        <td className="p-3 border font-medium">{item.type}</td>
                        <td className="p-3 border text-right">{item.rate}</td>
                        <td className="p-3 border text-right">{item.downPayment}</td>
                        <td className="p-3 border text-right">{item.quarterly}</td>
                        <td className="p-3 border text-right">{item.last}</td>
                        <td className="p-3 border text-right font-bold text-yellow-700">{item.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="mt-4 text-xs text-gray-500 bg-gray-50 p-4 rounded-lg">
                <p><strong>Note:</strong> Additional 10% will be charged for single category, 15% for double category & 20% for triple category. All terms & conditions set by Burj Quaid Management apply.</p>
                <p className="mt-1">WhatsApp: <a href={`https://wa.me/${content.whatsapp}`} className="text-green-600 underline">+{content.whatsapp}</a></p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h3 className="text-4xl font-bold">{content.hero.title}</h3>
          <p className="text-gray-400 text-lg mt-2">{content.hero.subtitle} • A Landmark of Ambition</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8">
            <button onClick={handleWhatsApp} className="bg-green-600 hover:bg-green-500 px-8 py-4 rounded-full inline-flex items-center gap-3 transition text-lg font-semibold">
              <Phone size={22} /> Contact via WhatsApp
            </button>
            <button onClick={() => setShowPaymentModal(true)} className="bg-yellow-500 hover:bg-yellow-400 text-black px-8 py-4 rounded-full inline-flex items-center gap-3 transition text-lg font-semibold">
              <FileText size={22} /> View Payment Plan
            </button>
            <button onClick={() => setShowFloorPlanModal(true)} className="bg-blue-600 hover:bg-blue-500 px-8 py-4 rounded-full inline-flex items-center gap-3 transition text-lg font-semibold">
              <Layers size={22} /> View Floor Plans
            </button>
          </div>
          <div className="mt-12 pt-8 border-t border-gray-800 text-sm text-gray-500">
            <p>© 2026 {content.hero.title}. All rights reserved. | Developed by ABS Developers</p>
            <p className="mt-1">Shariah-Compliant Real Estate • Transparency • Security • Trust</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BurjQuaidLanding;